import React from 'react';
import StatusSelect, { StatusSelectValueProps } from './StatusSelect';
import { SelectedStormModeStatusType } from './utils';

// TODO: сделать общими с подсказками в иконках
export const STORM_MODE_STATUS = Object.freeze({
  1: 'Штатный режим',
  2: 'Штормовой режим',
  unknown: 'Режим: Неизвестно',
});

export function StormModeStatusSelect(props: StatusSelectValueProps<SelectedStormModeStatusType>) {
  return (
    <StatusSelect
      {...props}
      statusDescription={STORM_MODE_STATUS}
      allValuesLabel="Все режимы"
    />
  );
}
export default StormModeStatusSelect;
